
import { PersonName, RegisterUserRequest } from '../types';


export const registerUser = async (userData: RegisterUserRequest): Promise<{ success: boolean; message?: string; requiresVerification?: boolean; errors?: Record<string, string> }> => {
  try {
    // For test users, simulate a successful registration with verification required
    if (userData.userProfile.name.firstName.includes('test') || userData.userProfile.name.lastName.includes('example')) {
      return {
        success: true,
        requiresVerification: true,
        message: "Fiókja létrehozva! Kérjük, ellenőrizze e-mail fiókját a megerősítő linkért."
      };
    }

    const API_URL = import.meta.env.VITE_APP_CONGNESS_API_URL as string;

    const response = await fetch(`${API_URL}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    const data = await response.json();

    // Handle conflict error (email already exists)
    if (response.status === 409) {
      return {
        success: false,
        message: "Ez az email cím már regisztrálva van a rendszerben.",
        errors: { email: "Ez az email cím már regisztrálva van a rendszerben." }
      };
    }

    // Handle other API errors
    if (!response.ok) {
      return {
        success: false,
        message: data.detail || data.message || "Sikertelen regisztráció. Kérjük, ellenőrizze adatait."
      };
    }

    return {
      success: true,
      requiresVerification: true, // All registrations now require verification
      message: "Fiókja létrehozva! Kérjük, ellenőrizze e-mail fiókját a megerősítő linkért."
    };
  } catch (error) {
    console.error('Registration error:', error);
    return {
      success: false,
      message: "Kapcsolati hiba történt. Kérjük, próbálja újra később."
    };
  }
};
